import {
  invalidateSearchQueries,
  isCanonicalSearchQuery,
} from "@/lib/data/react-query/search/invalidation";
import {
  createContactConnectionV1,
  deleteContactConnectionV1,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

export const useCreateContactConnection = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof createContactConnectionV1>[0]) =>
      createContactConnectionV1(data),
    onError: () => {
      toast.error("Error creating contact connection");
    },
    onSettled: async () => {
      await invalidateSearchQueries(queryClient);
      await queryClient.invalidateQueries({
        predicate: (query) => !isCanonicalSearchQuery(query),
        queryKey: [queryKeys.contact],
      });
    },
    onSuccess: () => {
      toast.success("Contact connection created successfully");
    },
  });
};

export const useDeleteContactConnection = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof deleteContactConnectionV1>[0]) =>
      deleteContactConnectionV1(data),
    onError: () => {
      toast.error("Error deleting contact connection");
    },
    onSettled: async () => {
      await invalidateSearchQueries(queryClient);
      await queryClient.invalidateQueries({
        predicate: (query) => !isCanonicalSearchQuery(query),
        queryKey: [queryKeys.contact],
      });
    },
    onSuccess: () => {
      toast.success("Contact connection deleted successfully");
    },
  });
};
